module.exports = __webpack_public_path__ + "static/media/tick.29937ff2.png";